import axios from 'axios';
import { API_URL } from '../helpers/Constant';
import { getAccessToken } from '../utils/common';

export const getDataWithToken = async (api) => {
  try {
    var response = await axios({
      method: 'GET',
      url: API_URL + api,
      headers: {
        Authorization: getAccessToken()
      }
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
}

export const getData = async (api) => {
  try {
    var response = await axios({
      method: 'get',
      url: API_URL + api
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
}

export const postDataWithToken = async (api, data) => {
  try {
    var response = await axios({
      method: 'POST',
      url: API_URL + api,
      data: data,
      headers: {
        Authorization: getAccessToken()
      }
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
}

export const postData = async (api, data) => {
  try {
    var response = await axios({
      method: 'POST',
      url: API_URL + api,
      data: data
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
}